import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-gray-50 text-gray-800 relative font-ubuntu">
      {/* Contenedor principal */}
      <div className="w-full max-w-screen-xl mx-auto p-6 md:py-10 z-10">
        {/* Sección superior */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Información del restaurante */}
          <div className='font-montserrat'>
            <h3 className="font-bold font-barlow text-lg mb-4">Contacto</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center space-x-3">
                <FaPhoneAlt />
                <span>+34 666 957 414</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhoneAlt />
                <span>+34 971 896 003</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaEnvelope />
                <span>eventos@txokomenorca.com</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaMapMarkerAlt />
                <span>Carrer Gregal, 11, Binisafua, 07711, Menorca</span>
              </li>
            </ul>
          </div>

          {/* Horarios de apertura */}
          <div className='font-ubuntu'>
            <h3 className="font-bold font-barlow text-lg mb-4">Horarios</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center space-x-3">
                <FaClock />
                <span>Mediodias de 12:00 a 17:00</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaClock />
                <span>Noches de 19:00 a 23:00</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaClock />
                <span>Lunes de 19:00 a 23:00</span>
              </li>
            </ul>
          </div>

          {/* Navegación adicional */}
          <div className='font-ubuntu'>
            <h3 className="font-bold font-barlow text-lg mb-4">Enlaces</h3>
            <ul className="flex flex-wrap gap-x-4 gap-y-2 text-sm">
              <li>
                <Link to="/" className="hover:underline">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/menu" className="hover:underline">
                  Menú
                </Link>
              </li>
              <li>
                <Link to="/gastronomy" className="hover:underline">
                  Gastronomía
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:underline">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:underline">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:underline">
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link to="/legal-notice" className="hover:underline">
                  Aviso Legal
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Separador visual */}
        <hr className="my-6 border-gray-300 sm:mx-auto lg:my-8" />

        {/* Sección de copyright */}
        <div className="text-center font-montserrat">
          <span className="block text-sm sm:text-center">
            © 2024{' '}
            <Link to="/" className="font-nunito font-medium hover:underline">
              Txoko
            </Link>
            . Todos los derechos reservados.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;